export default __webpack_public_path__ + "static/media/airdockz-cbb-banner-3.416d32cb.jpg";